webpackJsonp([253011397747672],{

/***/ 708:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.productPageQuery = exports.ProductPageTemplate = undefined;
	
	var _react = __webpack_require__(9);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactHelmet = __webpack_require__(244);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _reactIntl = __webpack_require__(23);
	
	var _Products = __webpack_require__(544);
	
	var _Products2 = _interopRequireDefault(_Products);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ProductPageTemplate = exports.ProductPageTemplate = function ProductPageTemplate(_ref) {
	  var helmet = _ref.helmet,
	      title = _ref.title,
	      products = _ref.products;
	  return _react2.default.createElement(
	    _react2.default.Fragment,
	    null,
	    helmet || '',
	    _react2.default.createElement(
	      'h1',
	      { className: 'is-hidden' },
	      _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'products' })
	    ),
	    _react2.default.createElement(_Products2.default, { items: products })
	  );
	};
	
	exports.default = function (_ref2) {
	  var data = _ref2.data;
	  var frontmatter = data.allProducts.frontmatter;
	
	  console.log('frontmatter', frontmatter);
	
	  return _react2.default.createElement(ProductPageTemplate, {
	    title: frontmatter.title,
	    products: frontmatter.products,
	    helmet: _react2.default.createElement(_reactHelmet2.default, {
	      title: '' + frontmatter.title,
	      meta: [{ name: 'charset', content: 'UTF-8' }, { name: 'description', content: '' + frontmatter.description }, { name: 'keywords', content: '' + frontmatter.keywords }]
	    })
	  });
	};
	
	var productPageQuery = exports.productPageQuery = '** extracted graphql fragment **';

/***/ })

});


// WEBPACK FOOTER //
// component---src-templates-product-page-js-0b7ee911202f9cad613e.js